/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecommendationTranslation
 */
export interface RecommendationTranslation {
    /**
     * 
     * @type {string}
     * @memberof RecommendationTranslation
     */
    authorAccountId: string;
    /**
     * 
     * @type {string}
     * @memberof RecommendationTranslation
     */
    message?: string;
}

/**
 * Check if a given object implements the RecommendationTranslation interface.
 */
export function instanceOfRecommendationTranslation(value: object): value is RecommendationTranslation {
    if (!('authorAccountId' in value) || value['authorAccountId'] === undefined) return false;
    return true;
}

export function RecommendationTranslationFromJSON(json: any): RecommendationTranslation {
    return RecommendationTranslationFromJSONTyped(json, false);
}

export function RecommendationTranslationFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecommendationTranslation {
    if (json == null) {
        return json;
    }
    return {
        
        'authorAccountId': json['authorAccountId'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function RecommendationTranslationToJSON(value?: RecommendationTranslation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'authorAccountId': value['authorAccountId'],
        'message': value['message'],
    };
}

